import React from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import AuthLayout from "../../layouts/AuthLayout";
import FormField from "../../components/FormField";
import RippleButton from "../../components/buttons/RippleButton";
import { resetPassword } from "../../redux/slices/authSlice";

const ResetPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);
  const { token } = useParams();

  const validationSchema = Yup.object({
    password: Yup.string()
      .matches(/^(?!\s)/, "Password cannot start with space")
      .min(8, "Password must be at least 8 characters")
      .matches(/[0-9]/, "Password requires a number")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter")
      .matches(/[\W_]/, "Password requires a symbol")
      .matches(/(?<!\s)$/, "Password cannot end with space")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  return (
    <AuthLayout rightContainerClassName="mt-226-sigin">
      <section>
        <h5 className="fs-22 fw-600 text-gray-900">Set a new Password</h5>
      </section>
      <section style={{ marginTop: "22px", width: "100%" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) => {
            delete values?.confirmPassword;
            dispatch(resetPassword({ data: values, token: token, navigate }));
            resetForm();
          }}
        >
          {() => (
            <Form className="row">
              <FormField
                label="New Password"
                name="password"
                type="password"
                fieldSize="col-12"
                labelFontColor="text-gray-950"
              />
              <FormField
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                fieldSize="col-12"
                labelFontColor="text-gray-950"
              />
              <div className="d-flex justify-content-end auth-login-button">
                <RippleButton type="submit" isLoading={loading}>
                  {t("COMMON.CONFIRM")}
                </RippleButton>
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </AuthLayout>
  );
};

export default ResetPassword;
